import CatalogTableReport from './CatalogTableReport';
import { BILLCOM_PO_RECONCILIATION } from '../../consts/reports';

const BillcomPoReconciliationReport = (props) => (
    <CatalogTableReport
        {...props}
        reportType={BILLCOM_PO_RECONCILIATION}
        title="Bill.com PO Reconciliation"
        description="Reconcile Bill.com payments against Eadin purchase-order payment records."
    />
);

export default BillcomPoReconciliationReport;
